import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=04409c91&"
import script from "./MediaGallery.vue?vue&type=script&lang=js&"
export * from "./MediaGallery.vue?vue&type=script&lang=js&"
import style0 from "./MediaGallery.vue?vue&type=style&index=0&id=04409c91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports